import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import QRCode from "react-qr-code";
import styles from "./arViewer.module.scss";
import { useParams } from "react-router-dom";
import CurrentContext from "../../../utils/CurrentContext";
import { ModelViewerCustom } from "./ModelViewerCustom";

export default function ARViewerCustom() {
  const [isDesktop, setIsDesktop] = useState(false);
  const {
    isAR,
    setIsAR,
    setLoading,
    ARModelSrc,
    ARUnicode,
    isARReady,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    arSrc, setArSrc,
  } = useContext(CurrentContext);
//   const [arSrc, setArSrc] = useState(null);
  const { token } = useParams();
  const btnRef = useRef();
  const modRef = useRef();

  const isDesktopRef = useRef();

  useEffect(() => {
    if (!ARModelSrc) return;
    setArSrc(ARModelSrc);
  }, [ARModelSrc]);

  const fetchArFile = () => {
    return new Promise((resolve, reject) => {
      const unicode = token || ARUnicode;
      if (!unicode) {
        reject(new Error("Token or ARUnicode is missing"));
        return;
      }

      setLoading(true);

    // const unicodeApiUrl =
    //   "https://stag4.imagine.io/configurator/api/v2/scene-ar-generator/?unicode=" +
    //   unicode;

      const unicodeApiUrl =
        "https://prod.imagine.io/configurator/api/v2/scene-ar-generator/?unicode=" +
        unicode;

      fetch(unicodeApiUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch AR file");
          }
          return response.json();
        })
        .then((data) => {
          console.log("DEBUG__finalData___", {
            token,
            ARUnicode,
            fileFetchedViaUnicode: data,
            unicodeApiUrl,
            arSrc,
            isARReady,
            ARModelSrc,
            url: `${window.location.origin}/p-ar/preview/${token || ARUnicode}`,
          });
          //   const filePath = data?.results?.file;
          // if (filePath) {
          //     const cleanUrl = new URL(filePath);
          //     cleanUrl.search = "";
          //     // console.log(cleanUrl.toString(),"clear pathhhhhh")
          //     setArSrc(cleanUrl.toString());
          // }
          setArSrc(data?.results[0]?.file);
          // setARUnicode(data?.results[0]?.unicode)
          console.log(data?.results[0]?.file, data, ARUnicode, "code");
          //   if (isDesktopRef?.current)
          setLoading(false);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  useEffect(() => {
    const userAgent = navigator?.userAgent;
    if (userAgent) {
      const flag =
        !/Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
          userAgent
        );
      setIsDesktop(flag);

      isDesktopRef.current = flag;
    }
    // const unicode = token || ARUnicode;
    fetchArFile();
  }, []);

  return (
    <>

      {/* {!(token || ARUnicode) ? (
        <AnimatedLoader
          backDrop={"transparent"}
          zIndex={1000}
          position="fixed"
          loading={true}
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      ) : null} */}

      <div
        className={styles.arContainer}
        style={
          token
            ? {
                height: "100dvh",
                padding: "0",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "1rem",
              }
            : {}
        }
      >
        {isDesktop ? (
        // {isDesktop && (token || ARUnicode) ? (
          <div className={styles.innerContainer}>
            <div className={styles.qrBox}>
              <QRCode
                value={`${window.location.origin}/p-ar/preview/${
                  token || ARUnicode
                }`}
                size={90}
                level="Q"
              />
            </div>
            <div className={styles.textContainer}>
              <h2 className={styles.title}>Show in your room (AR)</h2>
              <p className={styles.text}>
                Scan the QR code with the camera app on your mobile device.
              </p>
            </div>
          </div>
        ) : (
          <>
            {arSrc ? (
              <ModelViewerCustom
                url={arSrc}
                setUrl={setArSrc}
                setLoading={setLoading}
              />
            ) : null}
            {/* <img
                style={{
                width: "auto",
                height: "125px",
                display: "block",
                margin: "0 auto",
                }}
                src={getCurrentProductThumbnail()}
            /> */}

            {/* {arSrc && ARUnicode ? (
              <a
                // onClick={() => btnRef?.current?.click?.()}
                href={`${window.location.origin}/p-ar/preview/${token || ARUnicode}`}
                target="_blank"
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                  color: "#000",
                  margin: "1rem auto 0",
                  width: "auto",
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  background: "#f2f2f2",
                  border: "1px solid #e0e0e0",
                  borderRadius: 16,
                  boxShadow: "0px 0px 4px 1px rgba(140, 140, 140, 0.25)",
                }}
              >
                {/* <img width={16} src="/icons/btn_AR.svg" alt="export gltf" /> */}
                {/* <span>View in Your Space</span> */}
              {/* </a> */}
            {/* //</div>) : null} */}
          </>
        )}
      </div>
    </>
  );
}
